import script from "./PermissionForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./PermissionForm.vue?vue&type=script&setup=true&lang=ts"

import "./PermissionForm.vue?vue&type=style&index=0&id=61d79398&scooped=true&lang=css"

const __exports__ = script;

export default __exports__